import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: "vouchers",
    tagSub: "vouchers",
    exact: false,
    path: PATHS.VOUCHER.path,
    show: true,
    icon: "tag",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.VOUCHER_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "groups",
            group: "groups",
            tagSub: "vouchers",
            path: '/groups/list',
            exact: false,
            icon: 'tags',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.GROUP,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE,
                DEFINE.GENERAL.PERMISSION.UPDATE_PRICE, DEFINE.GENERAL.PERMISSION.VIEW_DETAIL
            ],
            children: [
                {
                    title: "createGroups",
                    group: "groups",
                    tagSub: "vouchers",
                    path: '/groups/action',
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateGroups",
                    group: "groups",
                    tagSub: "vouchers",
                    path: '/groups/action/:id',
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "voucherCodes",
            group: "vouchers",
            tagSub: "vouchers",
            path: '/vouchers/list',
            exact: false,
            icon: 'tag',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.VOUCHER,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE],
            children: [
                {
                    title: "createVouchers",
                    group: "vouchers",
                    tagSub: "vouchers",
                    path: '/vouchers/action',
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateVouchers",
                    group: "vouchers",
                    tagSub: "vouchers",
                    path: '/vouchers/action/:id',
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "importVouchers",
                    group: "vouchers",
                    tagSub: "vouchers",
                    path: '/vouchers/import',
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "properties",
            group: "properties",
            tagSub: "vouchers",
            path: '/properties/list',
            exact: false,
            icon: 'environment',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.PROPERTY,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createProperties",
                    group: "properties",
                    tagSub: "vouchers",
                    path: '/properties/action',
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateProperties",
                    group: "properties",
                    tagSub: "vouchers",
                    path: '/properties/action/:id',
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "products",
            group: "products",
            tagSub: "vouchers",
            path: '/products/list',
            exact: false,
            icon: 'shop',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.PRODUCT,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createProducts",
                    group: "products",
                    tagSub: "vouchers",
                    path: '/products/action',
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateProducts",
                    group: "products",
                    tagSub: "vouchers",
                    path: '/products/action/:id',
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "agents",
            group: "agents",
            tagSub: "vouchers",
            path: PATHS.AGENT.LIST.path,
            exact: false,
            icon: 'faStoreAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.AGENT,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE
            ],
            children: [
                {
                    title: "createAgents",
                    group: "agents",
                    tagSub: "vouchers",
                    path: PATHS.AGENT.CREATE.path,
                    exact: false,
                    icon: '',
                    show: false,
                }, {
                    title: "updateAgents",
                    group: "agents",
                    tagSub: "vouchers",
                    path: PATHS.AGENT.DETAIL.path,
                    exact: false,
                    icon: '',
                    show: false,
                }
            ]
        },
        {
            title: "groupCategories",
            group: "groupCategories",
            tagSub: "vouchers",
            path: PATHS.GROUP_CATEGORY.LIST.path,
            exact: false,
            icon: 'faTags',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.GROUP_CATEGORY,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createGroupCategories",
                    group: "groupCategories",
                    tagSub: "vouchers",
                    path: PATHS.GROUP_CATEGORY.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateGroupCategories",
                    group: "groupCategories",
                    tagSub: "vouchers",
                    path: PATHS.GROUP_CATEGORY.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                },
                {
                    title: "translateGroupCategories",
                    group: "groupCategories",
                    tagSub: "vouchers",
                    path: PATHS.GROUP_CATEGORY.DETAIL.TRANSLATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "checkVoucher",
            group: "checkVoucher",
            tagSub: "vouchers",
            path: '/vouchers/check',
            exact: false,
            icon: 'check',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.CHECK_VOUCHER,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.USE_VOUCHER],
        },
    ]
}]